import { render, staticRenderFns } from "./CommentCompetitionBanner.vue?vue&type=template&id=b2bb33c0&scoped=true&"
var script = {}
import style0 from "./CommentCompetitionBanner.vue?vue&type=style&index=0&id=b2bb33c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bb33c0",
  null
  
)

export default component.exports